import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import FormText from "react-bootstrap/FormText";

class Box extends React.Component {
  static get displayName() {
    return "Box";
  }

  static get propTypes() {
    return {
      title: PropTypes.node,
      subtitle: PropTypes.node,
      type: PropTypes.oneOf(["default", "solid"]),
      toolbox: PropTypes.node,
      noHeader: PropTypes.bool,
      className: PropTypes.string,
      children: PropTypes.node,
      onClick: PropTypes.func,
    };
  }

  static get defaultProps() {
    return {
      type: "solid",
      noHeader: false,
    };
  }

  render() {
    const { title, subtitle } = this.props;
    const boxClasses = classNames(
      this.props.className,
      "box",
      `box-${this.props.type}`,
    );

    const headerClasses = classNames({
      "box-header": true,
      hide: this.props.noHeader,
    });

    const toolboxClasses = classNames({
      "box-tools": true,
      "pull-right": true,
      hide: !this.props.toolbox,
    });

    return (
      <div className={boxClasses} onClick={this.props.onClick}>
        <div className={headerClasses}>
          <h3 className="box-title">{title}</h3>
          {subtitle && <FormText className="no-margin">{subtitle}</FormText>}
          <div className={toolboxClasses}>{this.props.toolbox}</div>
        </div>
        <div className="box-body">{this.props.children}</div>
      </div>
    );
  }
}

export default Box;
export { Box };
